import API, { defaultHeaders } from '@/api';
import Storage from '@/service/Storage';

const userSave = async(payload = {}) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/me`, {
    method: 'put',
    headers,
    body: JSON.stringify(payload),
  });
};

export default userSave;
